import { useLocation, useHistory, useParams } from 'react-router-dom';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Box, Button, Typography } from '@material-ui/core';
import ArrowCrumb from 'components/Icons/ArrowCrumb';
import ArrowFluxoPage from 'components/Icons/ArrowFluxoPage';
import './index.scss';
import { useSelector } from 'react-redux';
import { CONTRATO_ETAPAS_PARAMS_URL } from 'models/contratos';
import { Badge } from 'components/Badges/CustomBadge';

const getCategoriaURI = (pathname) => {
    const pathParts = pathname.split('/');
    const adminIndex = pathParts.indexOf('admin');
    if (adminIndex !== -1 && adminIndex + 1 < pathParts.length) {
        return pathParts[adminIndex + 1];
    }
    return '';
};

const getEtapaPageURI = (pathname) => {
    const pathParts = pathname.split('/');
    const adminIndex = pathParts.indexOf('admin');
    if (adminIndex !== -1 && adminIndex + 1 < pathParts.length) {
        const cadastroIndex = pathParts.indexOf('cadastro-de-contratos');
        const edicaoIndex = pathParts.indexOf('edicao-de-contratos');

        if (cadastroIndex !== -1) {
            const cadastroPart = pathParts[cadastroIndex];
            return (
                <span key={cadastroPart}>
                    {formatNamePage(cadastroPart)}
                </span>
            );
        } else if (edicaoIndex !== -1) {
            return (
                <span key='edicao'>
                    Edição de contratos
                </span>
            );
        }
    }
    return [];
};

const formatNamePage = (namePage) => {
    const formatted = namePage.replace(/-/g, ' ').toLowerCase();
    if (formatted.includes('ente publico descentralizado')) {
        return 'Ente público descentralizado';
    }
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

const getTipoEnteURI = (pathname) => {
    const pathParts = pathname.split('/');
    const adminIndex = pathParts.indexOf('admin');
    if (adminIndex !== -1 && adminIndex + 2 < pathParts.length) {
        return formatNamePage(pathParts[adminIndex + 2]);
    }
    return '';
};

const handleBreadcrumbNavigation = (history, route) => {
    history.push(route.path)
};

export const CustomBreadCrumbsContratos = ({ route }) => {
    const history = useHistory();
    const location = useLocation();
    const categoriaContratos = getCategoriaURI(location.pathname);
    const etapaContratos = getEtapaPageURI(location.pathname);
    const tipoEnteFluxo = getTipoEnteURI(location.pathname);
    const contratoFlgStatusDefinitivo = useSelector((state) => state.allContratos.statusDefinitivo)
    const params = useParams();
    const etapa = params.etapa;

    return (
        <>
            <Box className='custom-breadcrumbs__container'
            >
                <Box>
                    <div className='custom-breadcrumbs__container-fluxo'>
                        <Button
                            className='custom-breadcrumbs__link-fluxo-button'
                            startIcon={<ArrowFluxoPage color='#8C5F0F' />}
                            onClick={() => handleBreadcrumbNavigation(history, route)}
                        >
                        </Button>
                        <span className='custom-breadcrumbs__link-fluxo-text'>
                            {etapaContratos} - {tipoEnteFluxo}
                        </span>
                    </div>
                    <Breadcrumbs
                        separator={<ArrowCrumb color='#8C5F0F' />}
                        aria-label='breadcrumb'
                    >
                        <Button
                            className='custom-breadcrumbs__link-crumb-button'
                            onClick={() => handleBreadcrumbNavigation(history, route)}
                        >
                            <Typography
                                className='custom-breadcrumbs__link-crumb-text bold-text'>
                                {categoriaContratos}
                            </Typography>
                        </Button>

                        <Typography className='custom-breadcrumbs__link-crumb-text'>
                            {etapaContratos}
                        </Typography>
                    </Breadcrumbs>
                </Box>
                {etapa === CONTRATO_ETAPAS_PARAMS_URL.EDICAO ? (
                    <Box className='custom-breadcrumbs__container-badge'>
                        <span className='custom-breadcrumbs__span-badge'>
                            <Badge status={contratoFlgStatusDefinitivo} />
                        </span>
                    </Box>
                ) : (
                    <Box className='custom-breadcrumbs__container-badge'>
                        <span className='custom-breadcrumbs__span-badge'>
                            <Badge status={0} />
                        </span>
                    </Box>

                )}
            </Box>
        </>
    );
}